import { initializeMonitoring } from '../monitoring';
import { initializeBssdk } from '../security/bssdk';

// Monitoring starts independently and never gates security or application startup.
void initializeMonitoring();

// Start security protection before React mounts. API calls wait for this bounded,
// fail-open initialization through the local ticketFetch facade.
void initializeBssdk();
